<template>
  <v-menu
    v-if="items.length > 0"
    bottom
    origin="center center"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-bind="buttonAttrs || { icon: true }" v-on="on">
        <slot name="buttonContent">
          <v-icon>mdi-dots-vertical</v-icon>
        </slot>
      </v-btn>
    </template>
    <v-list>
      <v-list-item-group
        :value="value"
        @change="$emit('input', $event)"
        multiple
      >
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          @click.stop
          :value="item.value"
        >
          <template v-slot:default="{ active }">
            <v-list-item-action>
              <v-checkbox :input-value="active" color="primary"></v-checkbox>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MenuItemCheckboxInterface } from '@/domain/interface/intern/MenuItemCheckboxInterface';

@Component
export default class MenuButtonCheckbox extends Vue {
  @Prop(Array) readonly value!: MenuItemCheckboxInterface[];
  @Prop(Array) readonly items!: MenuItemCheckboxInterface[];
  @Prop(Object) readonly buttonAttrs?: object;
}
</script>
